import {SERVICE_NAMES} from '../constants';
import {createApiCall} from '../utils';
import type {ServiceName} from '../constants';
import type {
    ApiCallOptions,
    PaginatedResponse,
    AuditResource,
    AuditListParams
} from './api.d';

const createAuditApiCall = <T = any>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
    endpoint: string
) => createApiCall<T>(SERVICE_NAMES.AUDIT as ServiceName, method, endpoint);

export const auditApi = {
    getAudits: (
        transactionId: string,
        params?: AuditListParams,
        options?: ApiCallOptions
    ) => createAuditApiCall<PaginatedResponse<AuditResource>>(
        'GET',
        `transactions/${transactionId}/audits`
    )({...options, params})
};
